<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    newTitle="Adicionar Produto Produzido"
    newCreateButtonLabel="Adicionar Produto Produzido"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    @new-confirm-and-add-other-action="createEntryAndAddOther"
    :saveAndAddOtherButtonEnabled="true"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :seedPlotOperation="seedPlotOperation"
        :executionOperation="executionOperation"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    executionOperation: Object,
    seedPlotOperation: Object,
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.loadProducedProduct();        
    },
    loadProducedProduct: function() {
      this.error = null;
      this.loading = true;
      if(this.executionOperation){
        this.$apollo
          .query({
            query: NEW_END_PRODUCT_QUERY,
            variables: {
              periodIds: this.executionOperation.periodIdsAttribute
            },
            fetchPolicy: "no-cache"
          })
          .then(response => {
            // console.log("itens for produced_product", response);
            this.entry = response.data.groundContext.entryProducedProduct;
            this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }else if(this.seedPlotOperation){
        this.$apollo
          .query({
            query: NEW_SEEDLING_QUERY,
            variables: {
              operationTypeId: this.seedPlotOperation.operationType.id,
            },
            fetchPolicy: "no-cache"
          })
          .then(response => {
            // console.log("itens for produced_product", response);
            this.entry = response.data.groundContext.entrySeedling;
            this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    createEntryAndAddOther: function() {
      if (this.createEntry()){
        this.loadServerEntry();
        this.$refs.baseNew.newDialog = true;
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const NEW_END_PRODUCT_QUERY = gql `
  query($periodIds: [ID!]!) {
    groundContext {
      entryProducedProduct {
        id
        itemId
        item {
          id
          name
          unit {
            id
            name
          }
        }
        packagingId
        packaging {
          id
          name
          unitName
          size
          text
        }
        quantity
        storageId
        storage {
          id
          name
        }
        validations
      }
    }
    accountContext{
      availableEndProductsForCroppingInExecutionOperation(periodIds: $periodIds){
        id
        name
        cropLimit
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        group {
          id
          name
        }
      }
      allStorages {
        id
        name
        location
      }
    }
  }
`;

const NEW_SEEDLING_QUERY = gql `
  query($operationTypeId: ID){
    groundContext {
      entrySeedling {
        id
        itemId
        item {
          id
          name
          unit {
            id
            name
          }
        }
        packagingId
        packaging {
          id
          name
          unitName
          size
          text
        }
        quantity
        storageId
        storage {
          id
          name
        }
        validations
      }
    }
    accountContext{
      availableSeedlingsForCroppingInSeedPlotOperation(operationTypeId: $operationTypeId){
        id
        name
        cropLimit
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        group {
          id
          name
        }
      }
      allGreenhouses {
        id
        name
        location
      }
    }
  }
`;

</script>

<style scoped></style>
